(() => {
  const header = document.querySelector('.section-header');

  if (!header) return;

  const TOP_ZONE = 80;
  const DIRECTION_DISTANCE = 18;

  let previousY = Math.max(window.scrollY, 0);
  let direction = 0;
  let travelled = 0;
  let ticking = false;

  const menuIsOpen = () => Boolean(
    header.querySelector([
      '.drawer__container[open]',
      '.menu-opening',
      '.header.is-megamenu-open',
      '.header__nav-dropdown.is-visible'
    ].join(','))
  );

  const showHeader = () => {
    header.classList.remove('muzdan-header-hidden');
    header.classList.add('muzdan-header-visible');
    document.documentElement.classList.add(
      'muzdan-header-solid'
    );
  };

  const hideHeader = () => {
    header.classList.remove('muzdan-header-visible');
    header.classList.add('muzdan-header-hidden');
    document.documentElement.classList.remove(
      'muzdan-header-solid'
    );
  };

  const resetHeader = () => {
    header.classList.remove(
      'muzdan-header-hidden',
      'muzdan-header-visible'
    );
    document.documentElement.classList.remove(
      'muzdan-header-solid'
    );
  };

  const updateHeader = () => {
    ticking = false;

    const currentY = Math.max(window.scrollY, 0);
    const difference = currentY - previousY;

    if (currentY <= TOP_ZONE) {
      resetHeader();
      direction = 0;
      travelled = 0;
      previousY = currentY;
      return;
    }

    if (menuIsOpen()) {
      showHeader();
      direction = 0;
      travelled = 0;
      previousY = currentY;
      return;
    }

    if (difference === 0) return;

    const newDirection = difference > 0 ? 1 : -1;

    if (newDirection !== direction) {
      direction = newDirection;
      travelled = 0;
    }

    travelled += Math.abs(difference);

    if (travelled >= DIRECTION_DISTANCE) {
      if (direction === 1) {
        hideHeader();
      } else {
        showHeader();
      }

      travelled = 0;
    }

    previousY = currentY;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(updateHeader);
  }, { passive: true });
})();
